import affirmationDetails from "../Homepages/homeConfig";
import { useNavigate } from "react-router-dom";
import {
  MdClose,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";
import { useState } from "react";
import { setAffirm } from "../../reducers/userReducer";
import { useSelector } from "react-redux";

export default function ProsperityDetails() {
  const num = useSelector(setAffirm);
  const [slideIndex, setSlideIndex] = useState(num);
  const navigate = useNavigate();
  const details = affirmationDetails.affirmationDetails;
  const styles = {
    backgroundImage: "url(" + details[slideIndex-1].image + ")",
    backgroundSize: "cover",
    transition: "background-image ease-in-out 0.5s",
    color: "#000"
  };
  const nextSlide = () => {
    if(slideIndex !== details.length){
        setSlideIndex(slideIndex + 1)
    } 
    else if (slideIndex === details.length){
      setSlideIndex(1)
    }
  }
  const prevSlide = () => {
    if(slideIndex !== 1){
        setSlideIndex(slideIndex - 1)
    }
    else if (slideIndex === 1){
      setSlideIndex(details.length)
    }
  }
  return (
    <div className="prosperity" style={styles}>
      <div className="heading mb-3 mt-4">
        <MdClose
          size="40px"
          className="mx-3 mt-3"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/affirm/prosperity");
          }}
        />
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <MdKeyboardArrowLeft
          size="40px"
          className="mx-3"
          style={{ cursor: "pointer" }}
          onClick={()=>{
            prevSlide()
          }}
        />
        <h1 className="text-center">{details[slideIndex-1].quote}</h1>
        <MdKeyboardArrowRight
          size="40px"
          className="mx-3"
          style={{ cursor: "pointer" }}
          onClick={()=>{
            nextSlide()
          }}
        />
      </div>
    </div>
  );
}
